import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Quote,
  Star,
  Building2,
  ArrowRight,
  Users,
  Award,
  TrendingUp,
  Sparkles,
  CheckCircle,
  Zap,
  Globe,
  Shield,
  Heart,
} from "lucide-react";

// Import client logo images
import clients1 from "../img/clients/1.png";
import client2 from "../img/clients/2.png";
import client3 from "../img/clients/3.png";
import client4 from "../img/clients/4.png";
import clients5 from "../img/clients/5.png";
import client6 from "../img/clients/6.png";
import client7 from "../img/clients/7.png";
import client8 from "../img/clients/8.png";
import client9 from "../img/clients/9.png";
import client10 from "../img/clients/10.png";
import client11 from "../img/clients/11.png";
import clients12 from "../img/clients/12.png";
import clients13 from "../img/clients/13.png";
import clients14 from "../img/clients/14.png";
import client15 from "../img/clients/15.png";
import client16 from "../img/clients/16.png";
import client17 from "../img/clients/17.png";
import client18 from "../img/clients/18.png";
import client19 from "../img/clients/19.png";
import clients20 from "../img/clients/20.png";
import client21 from "../img/clients/21.png";
import client22 from "../img/clients/22.png";
import client23 from "../img/clients/23.png";
import client24 from "../img/clients/24.png";
import client25 from "../img/clients/25.png";
import clients26 from "../img/clients/26.png";
import client27 from "../img/clients/27.png";
import client28 from "../img/clients/28.png";
import client29 from "../img/clients/29.png";
import client30 from "../img/clients/30.png";
import client31 from "../img/clients/31.png";
import client32 from "../img/clients/32.png";
import client33 from "../img/clients/33.png";
import client34 from "../img/clients/34.png";
import client35 from "../img/clients/35.png";
import client36 from "../img/clients/36.png";
import client37 from "../img/clients/37.png";
import client38 from "../img/clients/38.png";
import clients39 from "../img/clients/39.png";
import client42 from "../img/clients/42.png";
import client43 from "../img/clients/43.png";
import client44 from "../img/clients/44.png";
import client45 from "../img/clients/45.png";
import client46 from "../img/clients/46.png";
import client47 from "../img/clients/47.png";
import client48 from "../img/clients/48.png";
import client49 from "../img/clients/49.png";
import client50 from "../img/clients/50.png";
import client51 from "../img/clients/51.png";
import client52 from "../img/clients/52.png";
import client53 from "../img/clients/53.png";
import client54 from "../img/clients/54.png";
import client55 from "../img/clients/55.png";
import client56 from "../img/clients/56.png";
import client57 from "../img/clients/57.png";
import client58 from "../img/clients/58.png";
import client59 from "../img/clients/59.png";
import client60 from "../img/clients/60.png";
import client61 from "../img/clients/61.png";
import client62 from "../img/clients/62.png";
import client63 from "../img/clients/63.png";
import client64 from "../img/clients/64.png";
import client65 from "../img/clients/65.png";
import client66 from "../img/clients/66.png";
import client67 from "../img/clients/67.png";
import client68 from "../img/clients/68.png";
import client71 from "../img/clients/71.png";
import client72 from "../img/clients/72.png";
import clients73 from "../img/clients/73.png";
import clients74 from "../img/clients/74.png";

// Additional client images that exist in folder
import client69 from "../img/clients/69.png";
import client70 from "../img/clients/70.png";
import client75 from "../img/clients/75.png";
import client76 from "../img/clients/76.png";
import client77 from "../img/clients/77.png";
import client78 from "../img/clients/78.png";
import client79 from "../img/clients/79.png";
import client80 from "../img/clients/80.png";
import client81 from "../img/clients/81.png";
import client82 from "../img/clients/82.png";
import client83 from "../img/clients/83.png";
import client84 from "../img/clients/84.png";
import client85 from "../img/clients/85.png";
import client86 from "../img/clients/86.png";
import client87 from "../img/clients/87.png";
import client88 from "../img/clients/88.png";
import client89 from "../img/clients/89.png";
import client90 from "../img/clients/90.png";
import client91 from "../img/clients/91.png";
import client92 from "../img/clients/92.png";
import client93 from "../img/clients/93.png";
import client94 from "../img/clients/94.png";

import "../css/ourcustomer.css";
function Ourcustomers() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Email submitted:", email);
  };

  // All client logos with gradients for variety
  const allClients = [
    { img: clients1, name: "Client 1", gradient: "from-blue-400 to-blue-600" },
    {
      img: client2,
      name: "Client 2",
      gradient: "from-purple-400 to-purple-600",
    },
    { img: client3, name: "Client 3", gradient: "from-green-400 to-green-600" },
    { img: client4, name: "Client 4", gradient: "from-red-400 to-red-600" },
    { img: clients5, name: "SBI", gradient: "from-blue-400 to-blue-600" },
    {
      img: client6,
      name: "Client 6",
      gradient: "from-indigo-400 to-indigo-600",
    },
    { img: client7, name: "Client 7", gradient: "from-pink-400 to-pink-600" },
    {
      img: client8,
      name: "Client 8",
      gradient: "from-yellow-400 to-yellow-600",
    },
    { img: client9, name: "Client 9", gradient: "from-teal-400 to-teal-600" },
    {
      img: client10,
      name: "Client 10",
      gradient: "from-orange-400 to-orange-600",
    },
    { img: client11, name: "Client 11", gradient: "from-cyan-400 to-cyan-600" },
    {
      img: clients12,
      name: "Client 12",
      gradient: "from-emerald-400 to-emerald-600",
    },
    {
      img: clients13,
      name: "Chitkara",
      gradient: "from-indigo-400 to-indigo-600",
    },
    {
      img: clients14,
      name: "McDonald's",
      gradient: "from-yellow-400 to-orange-500",
    },
    { img: client15, name: "Client 15", gradient: "from-rose-400 to-rose-600" },
    {
      img: client16,
      name: "Client 16",
      gradient: "from-violet-400 to-violet-600",
    },
    {
      img: client17,
      name: "Client 17",
      gradient: "from-amber-400 to-amber-600",
    },
    { img: client18, name: "Client 18", gradient: "from-lime-400 to-lime-600" },
    { img: client19, name: "Client 19", gradient: "from-sky-400 to-sky-600" },
    { img: clients20, name: "Vodafone", gradient: "from-red-400 to-red-600" },
    { img: client21, name: "Client 21", gradient: "from-blue-500 to-blue-700" },
    {
      img: client22,
      name: "Client 22",
      gradient: "from-purple-500 to-purple-700",
    },
    {
      img: client23,
      name: "Client 23",
      gradient: "from-green-500 to-green-700",
    },
    { img: client24, name: "Client 24", gradient: "from-red-500 to-red-700" },
    {
      img: client25,
      name: "Client 25",
      gradient: "from-indigo-500 to-indigo-700",
    },
    { img: clients26, name: "Walmart", gradient: "from-blue-500 to-blue-700" },
    { img: client27, name: "Client 27", gradient: "from-pink-500 to-pink-700" },
    {
      img: client28,
      name: "Client 28",
      gradient: "from-yellow-500 to-yellow-700",
    },
    { img: client29, name: "Client 29", gradient: "from-teal-500 to-teal-700" },
    {
      img: client30,
      name: "Client 30",
      gradient: "from-orange-500 to-orange-700",
    },
    { img: client31, name: "Client 31", gradient: "from-cyan-500 to-cyan-700" },
    {
      img: client32,
      name: "Client 32",
      gradient: "from-emerald-500 to-emerald-700",
    },
    { img: client33, name: "Client 33", gradient: "from-rose-500 to-rose-700" },
    {
      img: client34,
      name: "Client 34",
      gradient: "from-violet-500 to-violet-700",
    },
    {
      img: client35,
      name: "Client 35",
      gradient: "from-amber-500 to-amber-700",
    },
    { img: client36, name: "Client 36", gradient: "from-lime-500 to-lime-700" },
    { img: client37, name: "Client 37", gradient: "from-sky-500 to-sky-700" },
    { img: client38, name: "Client 38", gradient: "from-blue-600 to-blue-800" },
    {
      img: clients39,
      name: "Haveli",
      gradient: "from-orange-400 to-orange-600",
    },
    {
      img: client42,
      name: "Client 42",
      gradient: "from-purple-600 to-purple-800",
    },
    {
      img: client43,
      name: "Client 43",
      gradient: "from-green-600 to-green-800",
    },
    { img: client44, name: "Client 44", gradient: "from-red-600 to-red-800" },
    {
      img: client45,
      name: "Client 45",
      gradient: "from-indigo-600 to-indigo-800",
    },
    { img: client46, name: "Client 46", gradient: "from-pink-600 to-pink-800" },
    {
      img: client47,
      name: "Client 47",
      gradient: "from-yellow-600 to-yellow-800",
    },
    { img: client48, name: "Client 48", gradient: "from-teal-600 to-teal-800" },
    {
      img: client49,
      name: "Client 49",
      gradient: "from-orange-600 to-orange-800",
    },
    { img: client50, name: "Client 50", gradient: "from-cyan-600 to-cyan-800" },
    {
      img: client51,
      name: "Client 51",
      gradient: "from-emerald-600 to-emerald-800",
    },
    { img: client52, name: "Client 52", gradient: "from-rose-600 to-rose-800" },
    {
      img: client53,
      name: "Client 53",
      gradient: "from-violet-600 to-violet-800",
    },
    {
      img: client54,
      name: "Client 54",
      gradient: "from-amber-600 to-amber-800",
    },
    { img: client55, name: "Client 55", gradient: "from-lime-600 to-lime-800" },
    { img: client56, name: "Client 56", gradient: "from-sky-600 to-sky-800" },
    { img: client57, name: "Client 57", gradient: "from-blue-700 to-blue-900" },
    {
      img: client58,
      name: "Client 58",
      gradient: "from-purple-700 to-purple-900",
    },
    {
      img: client59,
      name: "Client 59",
      gradient: "from-green-700 to-green-900",
    },
    { img: client60, name: "Client 60", gradient: "from-red-700 to-red-900" },
    {
      img: client61,
      name: "Client 61",
      gradient: "from-indigo-700 to-indigo-900",
    },
    { img: client62, name: "Client 62", gradient: "from-pink-700 to-pink-900" },
    {
      img: client63,
      name: "Client 63",
      gradient: "from-yellow-700 to-yellow-900",
    },
    { img: client64, name: "Client 64", gradient: "from-teal-700 to-teal-900" },
    {
      img: client65,
      name: "Client 65",
      gradient: "from-orange-700 to-orange-900",
    },
    { img: client66, name: "Client 66", gradient: "from-cyan-700 to-cyan-900" },
    {
      img: client67,
      name: "Client 67",
      gradient: "from-emerald-700 to-emerald-900",
    },
    { img: client68, name: "Client 68", gradient: "from-rose-700 to-rose-900" },
    {
      img: client71,
      name: "Client 71",
      gradient: "from-violet-700 to-violet-900",
    },
    {
      img: client72,
      name: "Client 72",
      gradient: "from-amber-700 to-amber-900",
    },
    {
      img: clients73,
      name: "JW Marriott",
      gradient: "from-purple-400 to-purple-600",
    },
    {
      img: clients74,
      name: "Taj Group",
      gradient: "from-purple-500 to-purple-700",
    },
    {
      img: client69,
      name: "Client 69",
      gradient: "from-slate-400 to-slate-600",
    },
    { img: client70, name: "Client 70", gradient: "from-zinc-400 to-zinc-600" },
    {
      img: client75,
      name: "Client 75",
      gradient: "from-neutral-400 to-neutral-600",
    },
    {
      img: client76,
      name: "Client 76",
      gradient: "from-stone-400 to-stone-600",
    },
    { img: client77, name: "Client 77", gradient: "from-red-400 to-pink-600" },
    {
      img: client78,
      name: "Client 78",
      gradient: "from-orange-400 to-red-600",
    },
    {
      img: client79,
      name: "Client 79",
      gradient: "from-amber-400 to-orange-600",
    },
    {
      img: client80,
      name: "Client 80",
      gradient: "from-yellow-400 to-amber-600",
    },
    {
      img: client81,
      name: "Client 81",
      gradient: "from-lime-400 to-yellow-600",
    },
    {
      img: client82,
      name: "Client 82",
      gradient: "from-green-400 to-lime-600",
    },
    {
      img: client83,
      name: "Client 83",
      gradient: "from-emerald-400 to-green-600",
    },
    {
      img: client84,
      name: "Client 84",
      gradient: "from-teal-400 to-emerald-600",
    },
    { img: client85, name: "Client 85", gradient: "from-cyan-400 to-teal-600" },
    { img: client86, name: "Client 86", gradient: "from-sky-400 to-cyan-600" },
    { img: client87, name: "Client 87", gradient: "from-blue-400 to-sky-600" },
    {
      img: client88,
      name: "Client 88",
      gradient: "from-indigo-400 to-blue-600",
    },
    {
      img: client89,
      name: "Client 89",
      gradient: "from-violet-400 to-indigo-600",
    },
    {
      img: client90,
      name: "Client 90",
      gradient: "from-purple-400 to-violet-600",
    },
    {
      img: client91,
      name: "Client 91",
      gradient: "from-fuchsia-400 to-purple-600",
    },
    {
      img: client92,
      name: "Client 92",
      gradient: "from-pink-400 to-fuchsia-600",
    },
    { img: client93, name: "Client 93", gradient: "from-rose-400 to-pink-600" },
    { img: client94, name: "Client 94", gradient: "from-red-400 to-rose-600" },
  ];

  const testimonials = [
    {
      id: 1,
      name: "SAHIL SAINI",
      company: "JW MARRIOTT CHANDIGARH",
      description:
        "We are very happy with your dealing in J W Marriott Chandigarh and services/Product is so much appreciable and Spinoff Team support us fabulous!",
      rating: 5,
    },
    {
      id: 2,
      name: "Jai Upadhyay",
      company: "GMP TECHNICAL SOLUTION",
      description: "Clean room LED Light Fixtures product performance is Good.",
      rating: 5,
    },
    {
      id: 3,
      name: "Kewal Krishan",
      company: "Kewal Krishan Govt Contractor",
      description:
        "Been dealing with Spinoff for almost a year now. Their products are reliable and the team always responds quickly whenever we face any issue in Kathua. Very satisfied.",
      rating: 5,
    },
    {
      id: 4,
      name: "Sunil Kumar Gupta",
      company: "Sangeet Palace",
      description:
        "We ordered a good quantity for our Udhampur project. Everything reached in perfect condition and the pricing was better than local market. Happy with the service.",
      rating: 4,
    },
    {
      id: 5,
      name: "Ranjit Kumar",
      company: "J.S. Brother Electricals",
      description:
        "Best battery and power solution supplier we have worked with in Jammu. Timely delivery and genuine products. Will definitely order again.",
      rating: 5,
    },
    {
      id: 6,
      name: "Javid Ahamed",
      company: "JAY EMM ELECTRONICS",
      description:
        "Anantnag market is tough but Spinoff made it easy. Good quality inverters and batteries at reasonable rates. Their after-sales support is also prompt.",
      rating: 5,
    },
    {
      id: 7,
      name: "Bilal",
      company: "M S Bhatt Build Construction",
      description:
        "We used their products in multiple construction sites. Performance is good and the team is very cooperative. Recommended.",
      rating: 4,
    },
    {
      id: 8,
      name: "Sumit",
      company: "Rudra Power Solutions",
      description:
        "Mukerian wale bhaiyon ke liye best option hai Spinoff. Products are durable and service is fast. Long-term relationship ban gaya hai.",
      rating: 5,
    },
    {
      id: 9,
      name: "Gaurav Kumar",
      company: "Rupam Traders",
      description:
        "Araria se order kiya tha, delivery on time aur quality top class. Ab regular customer ban gaye hain.",
      rating: 5,
    },
    {
      id: 10,
      name: "J.N. Chaudhary",
      company: "Siddhi Vinayak Enterprises",
      description:
        "Patna mein itna accha support koi nahi deta. Spinoff team is always ready to help. Products are genuine and pricing is competitive.",
      rating: 5,
    },
    {
      id: 11,
      name: "Amrudin Anshari",
      company: "Nancy Traders",
      description:
        "Small town business but they treat us like big clients. Very happy with the solar and battery range they supplied.",
      rating: 4,
    },
    {
      id: 12,
      name: "Sushil Singh",
      company: "National Trading",
      description:
        "Madhubani se regular dealing kar rahe hain. Products ki life achhi hai aur return policy bhi flexible hai. Thank you Spinoff!",
      rating: 5,
    },
    {
      id: 13,
      name: "Vijay Kumar",
      company: "Janta Enterprise",
      description:
        "Rohtas district mein hamare liye reliable partner ban gaye hain. Fast delivery and good technical support.",
      rating: 5,
    },
    {
      id: 14,
      name: "Siddhartha Gautam",
      company: "Mahabodhi Motors",
      description:
        "Bodh Gaya ke liye battery aur power backup solutions bahut accha mila. Customer service is really responsive.",
      rating: 5,
    },
    {
      id: 15,
      name: "Narayan Singh",
      company: "Aaditya & Aadarsh Enterprises",
      description:
        "Deoghar se order kiya, quality aur pricing dono satisfied kiye. Team ne personally follow-up kiya.",
      rating: 4,
    },
    {
      id: 16,
      name: "SUNIL SONGIRE",
      company: "EXCLUSIVE ENTERPRISES",
      description:
        "Indore mein hamara experience bahut positive raha. Products are premium and support is excellent.",
      rating: 5,
    },
    {
      id: 17,
      name: "Maruti Jadhav",
      company: "Trilligent Solutions",
      description:
        "Pune market mein Spinoff products are gaining good reputation. We are happy with the performance and service.",
      rating: 5,
    },
    {
      id: 18,
      name: "Vijay Meshram",
      company: "Tanushri Power Solutions",
      description:
        "Pune se dealing kar rahe hain last 8 months. No complaints at all. Keep up the good work!",
      rating: 5,
    },
    {
      id: 19,
      name: "Prashant Mujumdar",
      company: "Jaynath Associates",
      description:
        "Kolhapur ke liye unka solar range bahut accha hai. Delivery time bhi fast hai.",
      rating: 4,
    },
    {
      id: 20,
      name: "Abdul Shakeel",
      company: "ALPHA ENTERPRISES",
      description:
        "Aurangabad se regular orders dete hain. Products ki quality consistent hai aur team supportive hai.",
      rating: 5,
    },
    {
      id: 21,
      name: "Nageswara Rao",
      company: "Jyothi Electronics",
      description:
        "Guntur mein local market se better rates aur better quality mila Spinoff se. Happy customer.",
      rating: 5,
    },
    {
      id: 22,
      name: "Sree Ram",
      company: "Akshaya Traders",
      description:
        "Visakhapatnam se first time order kiya tha, ab repeat orders chal rahe hain. Very good experience.",
      rating: 5,
    },
    {
      id: 23,
      name: "Rajesh Kumar",
      company: "PVR TECHNOLOGIES",
      description:
        "Bengaluru mein high quality products chahiye the, Spinoff ne deliver kiya. Professional team.",
      rating: 5,
    },
    {
      id: 24,
      name: "Jubin",
      company: "Green Power Traders",
      description:
        "Kollam, Kerala se dealing kar rahe hain. Products are excellent and service is very friendly.",
      rating: 5,
    },
  ];

  const clientCategories = [
    {
      title: "Hospitality",
      description: "Premium hotels and restaurants",
      clients: ["JW Marriott", "Taj Group", "McDonald's", "Haveli"],
      icon: Building2,
      gradient: "from-blue-400 to-indigo-600",
      bgGradient: "from-blue-50 to-indigo-50",
      borderColor: "border-blue-200",
    },
    {
      title: "Healthcare",
      description: "Leading pharmaceutical companies",
      clients: ["Morepen", "MDC Pharma", "USV", "Glenmark"],
      icon: Award,
      gradient: "from-emerald-400 to-teal-600",
      bgGradient: "from-emerald-50 to-teal-50",
      borderColor: "border-emerald-200",
    },
    {
      title: "Education",
      description: "Top educational institutions",
      clients: [
        "Chitkara",
        "Chandigarh University",
        "Mount Carmel School",
        "Euro Kids",
      ],
      icon: Users,
      gradient: "from-violet-400 to-indigo-600",
      bgGradient: "from-violet-50 to-indigo-50",
      borderColor: "border-violet-200",
    },
    {
      title: "Corporate",
      description: "Fortune 500 companies and banks",
      clients: ["SBI", "Walmart", "Vodafone", "JLL"],
      icon: TrendingUp,
      gradient: "from-amber-400 to-orange-600",
      bgGradient: "from-amber-50 to-orange-50",
      borderColor: "border-amber-200",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-blue-400/20 to-indigo-600/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-cyan-400/20 to-blue-600/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-gradient-to-br from-indigo-400/10 to-purple-600/10 rounded-full blur-3xl"></div>
      </div>

      {/* Hero Section - Rich with Colors and Effects */}
      <section
        className="pt-2 pb-20 px-6 text-center relative overflow-hidden"
        style={{ marginTop: "80px" }}
      >
        {/* Rich Background Layers */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-100 via-white to-blue-100 opacity-60"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-100/40 via-transparent to-transparent"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          {/* Enhanced Feature Pill with Gradient */}
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full text-sm font-medium text-white mb-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
            <Sparkles className="w-5 h-5 text-yellow-300" />
            <span className="bg-gradient-to-r from-yellow-200 to-yellow-100 bg-clip-text text-transparent font-bold">
              500+
            </span>{" "}
            Trusted Partners Worldwide
            <Zap className="w-4 h-4 text-yellow-300 animate-pulse" />
          </div>

          {/* Rich Main Headline with Multiple Gradients */}
          <h1 className="text-6xl md:text-6xl font-extrabold tracking-tighter mb-8 leading-tight">
            <span className="bg-gradient-to-r from-slate-900 via-indigo-900 to-slate-900 bg-clip-text text-transparent">
              Our Valued Customers
            </span>
          </h1>

          {/* Enhanced Subtext with Gradient */}
          <p className="text-2xl text-slate-600 mb-16 max-w-4xl mx-auto leading-relaxed bg-gradient-to-r from-slate-600 to-slate-500 bg-clip-text text-transparent">
            Our mission is always on enhancing customer satisfaction by
            innovation and consistent quality control; thereby ensuring Value
            for Money for every partnership we build.
          </p>

          {/* Rich Stats with Gradient Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-20">
            <div className="group relative bg-gradient-to-br from-white to-blue-50 border border-blue-200/50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400/10 to-purple-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-5xl font-black bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3">
                  500+
                </div>
                <div className="text-slate-600 text-base font-semibold">
                  Happy Clients
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-blue-400 to-purple-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-emerald-50 border border-emerald-200/50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 to-teal-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-5xl font-black bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-3">
                  10+
                </div>
                <div className="text-slate-600 text-base font-semibold">
                  Years Trust
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-emerald-400 to-teal-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-rose-50 border border-rose-200/50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-rose-400/10 to-pink-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-5xl font-black bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent mb-3">
                  99%
                </div>
                <div className="text-slate-600 text-base font-semibold">
                  Satisfaction
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-rose-400 to-pink-600 rounded-full"></div>
            </div>

            <div className="group relative bg-gradient-to-br from-white to-amber-50 border border-amber-200/50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/10 to-orange-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="text-5xl font-black bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent mb-3">
                  Quick
                </div>
                <div className="text-slate-600 text-base font-semibold">
                  Support
                </div>
              </div>
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-amber-400 to-orange-600 rounded-full"></div>
            </div>
          </div>

          {/* Rich CTA Buttons with Gradients */}
         {/* <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button className="group relative px-8 py-4 bg-gradient-to-r from-slate-900 to-slate-800 text-white rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative z-10 flex items-center">
                <a href="#case-studies" className="text-white">
                  View All Success Stories
                </a>
                <ArrowRight className="inline-block ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
              <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
            </button>
          </div>*/}
        </div>
      </section>

      {/* Rich Industry Categories Section */}
      <section className="py-2 px-6 relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-50 via-white to-blue-50 opacity-50"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full text-sm font-medium text-white mb-8 shadow-lg">
              <Building2 className="w-5 h-5 text-yellow-300" />
              Industry Expertise
              <Globe className="w-4 h-4 text-yellow-300 animate-spin-slow" />
            </div>

            <h2 className="text-5xl md:text-5xl font-black mb-8 tracking-tight">
              <span className="bg-gradient-to-r from-slate-900 via-indigo-900 to-purple-900 bg-clip-text text-transparent">
                Industry Leaders
              </span>
              <br />
              <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                We Serve
              </span>
            </h2>

            <p className="text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed bg-gradient-to-r from-slate-600 to-slate-500 bg-clip-text text-transparent">
              Powering diverse sectors with our innovative solutions and trusted
              partnerships
            </p>
          </div>

          {/* Modern Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-4 gap-8">
            {clientCategories.map((category, index) => {
              const Icon = category.icon;

              return (
                <div
                  key={category.title}
                  className="group relative bg-white border border-gray-200 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden"
                >
                  {/* Gradient Border on Hover */}
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${category.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}
                  ></div>
                  <div
                    className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${category.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}
                  ></div>

                  <div className="relative z-10">
                    {/* Icon */}
                    <div
                      className={`w-16 h-16 bg-gradient-to-br ${category.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}
                    >
                      <Icon className="w-8 h-8 text-white" />
                    </div>

                    {/* Content */}
                    <h3
                      className={`text-2xl font-bold mb-3 bg-gradient-to-r ${category.gradient} bg-clip-text text-transparent`}
                    >
                      {category.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {category.description}
                    </p>

                    {/* Clients List */}
                    <div className="space-y-3">
                      {category.clients.map((client, idx) => (
                        <div key={idx} className="flex items-center gap-3">
                          <div
                            className={`w-2 h-2 bg-gradient-to-r ${category.gradient} rounded-full`}
                          ></div>
                          <span className="text-gray-700 font-medium group-hover:text-gray-900 transition-colors">
                            {client}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Rich Testimonials Section */}
      <section className="py-2 px-6 relative overflow-hidden" id="case-studies">
        {/* Rich Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-white to-blue-50"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-indigo-100/30 via-transparent to-transparent"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full text-sm font-medium text-white mb-8 shadow-lg">
              <Quote className="w-5 h-5 text-yellow-300" />
              Client Success Stories
              <Heart className="w-4 h-4 text-red-300 animate-pulse" />
            </div>

            <h2 className="text-5xl md:text-5xl font-black mb-8 tracking-tight">
              <span className="bg-gradient-to-r from-slate-900 via-purple-900 to-pink-900 bg-clip-text text-transparent">
                What Our Clients Say
              </span>
              <br />
              <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 bg-clip-text text-transparent"></span>
            </h2>

            <p className="text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed bg-gradient-to-r from-slate-600 to-slate-500 bg-clip-text text-transparent">
              Don't just take our word for it—hear from our satisfied partners
              who have transformed their businesses with Spinoff
            </p>
          </div>

          {/* Modern Testimonial Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden"
              >
                {/* Gradient Top Border */}
                <div className="h-2 bg-gradient-to-r from-indigo-500 to-purple-600"></div>

                <div className="p-8">

                  {/* Quote */}
                  <blockquote className="text-gray-700 leading-relaxed mb-6 text-lg">
                    "{testimonial.description}"
                  </blockquote>

                  {/* Author Info */}
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center">
                      <span className="text-white font-bold text-lg">
                        {testimonial.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">
                        {testimonial.name}
                      </h4>
                      <p className="text-indigo-600 font-medium">
                        {testimonial.company}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-purple-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Partners - Static Responsive Grid (No Animation Issues) */}
      <section className="py-24 px-6 bg-gradient-to-b from-indigo-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-500 to-blue-600 rounded-full text-sm font-medium text-white mb-8 shadow-lg">
              <Users className="w-5 h-5 text-yellow-300" />
              Trusted Brands
              <Shield className="w-4 h-4 text-green-300" />
            </div>

            <h2 className="text-5xl md:text-5xl font-black mb-6 tracking-tight">
              <span className="bg-gradient-to-r from-slate-900 via-indigo-900 to-blue-900 bg-clip-text text-transparent">
                Our Valued Partners
              </span>
            </h2>
            <p className="text-2xl text-slate-600 max-w-2xl mx-auto">
              90+ organizations that trust Spinoff for their power solutions
            </p>
          </div>

          {/* Responsive Grid - All logos will show clearly */}
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-6">
            {allClients.map((client, index) => (
              <div
                key={index}
                className="group bg-white border border-slate-200 rounded-2xl p-6 flex items-center justify-center hover:shadow-lg hover:border-indigo-200 transition-all duration-300 hover:-translate-y-1"
              >
                <img
                  src={client.img}
                  alt={client.name}
                  className="h-14 md:h-16 w-auto object-contain  group-hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ))}
          </div>

          <p className="text-center text-slate-500 mt-12 text-sm">
            ...and many more happy clients across India
          </p>
        </div>
      </section>

      {/* Rich Contact Footer */}
      <section className="py-2 px-6 relative overflow-hidden">
        {/* Rich Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-indigo-600/20 via-transparent to-transparent"></div>

        {/* Animated Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 right-20 w-48 h-48 bg-gradient-to-br from-indigo-400/20 to-blue-600/20 rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-20 left-20 w-56 h-56 bg-gradient-to-br from-cyan-400/20 to-indigo-600/20 rounded-full blur-3xl animate-float-delayed"></div>
        </div>

        <div className="max-w-5xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-500 to-blue-600 rounded-full text-sm font-medium text-white mb-8 shadow-2xl">
            <Users className="w-5 h-5 text-yellow-300" />
            Let's Connect
            <Heart className="w-4 h-4 text-red-300 animate-pulse" />
          </div>

          <h2 className="text-5xl md:text-5xl font-black mb-8 tracking-tight">
            <span className="text-white">Let's Build Something</span>
            <br />
            <span className="bg-gradient-to-r from-indigo-400 via-blue-400 to-cyan-400 bg-clip-text text-transparent">
              Great Together
            </span>
          </h2>

          <p className="text-2xl text-white/80 mb-16 max-w-3xl mx-auto leading-relaxed">
            Join 500+ companies that trust Spinoff for their power electronics
            solutions and experience the difference true partnership makes.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white placeholder-white/50 focus:outline-none focus:border-white/40 focus:bg-white/15 transition-all duration-300 shadow-lg"
              required
            />
            <button
              type="submit"
              className="group relative px-10 py-4 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-full font-bold transition-all duration-300 hover:scale-105 shadow-2xl hover:shadow-3xl overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative z-10 flex items-center">
                Contact Sales
                <ArrowRight className="inline-block ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
            </button>
          </form>

          <p className="text-sm text-white/60 mt-8 font-medium">
            No pressure. Just a conversation about your needs.
          </p>
        </div>
      </section>

      {/* Enhanced Custom CSS */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          
          @keyframes float-delayed {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
          }
          
          @keyframes gradient {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }
          
          @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          
          .animate-marquee {
            animation: marquee 4s linear infinite;
          }
          
          .animate-marquee:hover {
            animation-play-state: paused;
          }
          
          .animate-float {
            animation: float 6s ease-in-out infinite;
          }
          
          .animate-float-delayed {
            animation: float-delayed 8s ease-in-out infinite;
          }
          
          .animate-gradient {
            background-size: 200% 200%;
            animation: gradient 3s ease infinite;
          }
          
          .animate-spin-slow {
            animation: spin-slow 8s linear infinite;
          }
          
          .drop-shadow-sm {
            filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1));
          }
          
          .drop-shadow-lg {
            filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04));
          }
        `,
        }}
      />
    </div>
  );
}

export default Ourcustomers;
